module.exports = __webpack_public_path__ + "img/Postmodernisme_Lillebjorn-Nilsen.b1edf456.jpg";